<template>
  <div>
    <div class="bg-white shadow sm:rounded-lg my-5">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          {{ title }}
        </h3>
        <div class="mt-2 sm:flex sm:items-start sm:justify-between">
          <div class="max-w-xl text-sm leading-5 text-gray-500">
            <p>
              Complete the steps in the guide and apply for approval. We will
              manually check your store checkout page to verify the changes.
            </p>
          </div>
          <div
            class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
          >
            <span class="inline-flex rounded-md shadow-sm">
              <button
                type="button"
                class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150"
                @click="openOptinModal"
              >
                View guide
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <OptinOnboardingModal v-if="showModal" @close="showModal = false" />
  </div>
</template>

<script>
import OptinOnboardingModal from "./OptinOnboardingModal.vue";

export default {
  components: {
    OptinOnboardingModal
  },
  props: {
    title: { type: String }
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    openOptinModal() {
      this.showModal = true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
